<!-- svelte-ignore a11y-click-events-have-key-events -->
<script>
	import { TwitchIcon, VideoIcon, ChevronDownIcon, ChevronRightIcon, MailIcon } from 'svelte-feather-icons'
	import { faDiscord } from '@fortawesome/fontawesome-free-brands';
	import { createEventDispatcher } from 'svelte';
	var dispatch = createEventDispatcher();
	import { onMount } from 'svelte';
	import { io } from './store.js';
	
	var emailInfo = {
		name: '',
		email: '',
		subject: '',
		body: ''
	};

	var verifyData = { test: "wasup" };
	var success = false;


	onMount(() => {
		const urlParams = new URLSearchParams(window.location.search);
		verifyData.discordId = urlParams.get('discord');
		verifyData.verify = urlParams.get('verify');

		if(urlParams.get('success')){
			success = true;
		}

		console.log(verifyData, urlParams);
		console.log($io)
		window.io = $io;
	});

</script>

<div class='con-page'>
	<div class='con-dash'>
		
		<div class='landing-header y'>
			{success ? "Verification Success!" : "Discord Verification"}
		</div>

		{#if !success}
		<div style='margin:40px;'>
			<form action="/submit" method="POST">
				<div id="recaptcha-container"></div>				
				<input style='width:100px; margin:20px;' type="submit" name="submit" class="btn btn-primary" value="Verify">
				<input type="hidden" name="jsonData" 
					value="{JSON.stringify(verifyData)}">
			</form>
		</div>
		{/if}

		<hr />

	</div>
</div>

<style type="text/less">

	form{
		display:grid;
		justify-items:center;
	}

	.g-recaptcha{
		width:100%;
		display:grid;
		justify-items:center;
	}

	hr{
		margin:30px 0;
	}

	p{
		color:rgba(255, 255, 255, 0.904);
		margin:15px;
		font-weight:500;
	}
	.con-page{
		display:grid;
	}
	.con-dash{
		display:grid;
		justify-self:center;
		width: 100%;
		max-width:var(--mwidth);
		//margin-top:30px;
		margin-top:10px;
		padding:30px;
	}

	.landing-header-s{
		font-weight:bold;
		font-size:1.5em;
	}

	.landing-header{
		text-align:center;
		font-weight:bold;
		font-size:3em;
	}

</style>